import React from 'react'

import "../../assets/styles/nav/nav-very-top.scss"

export default function VeryTop() {
  return (
    <ul className="nav-very-top">
      <li><a href="https://www.shatterproof.org/nationalmemorial" target="_blank" rel="noopener noreferrer">National Addiction Memorial</a></li>
      <li><a href="https://www.shatterproof.org/blog" target="_blank" rel="noopener noreferrer">Blog</a></li>
      <li><a href="https://www.shatterproof.org/search/content" target="_blank" rel="noopener noreferrer">Search</a></li>
    </ul>
  )
}
